import { render, staticRenderFns } from "./projectMainForm.vue?vue&type=template&id=15b21173&"
import script from "./projectMainForm.vue?vue&type=script&lang=js&"
export * from "./projectMainForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports